import { render } from "./P081.vue?vue&type=template&id=e9137360&scoped=true"
import script from "./P081.vue?vue&type=script&lang=js"
export * from "./P081.vue?vue&type=script&lang=js"

import "./P081.vue?vue&type=style&index=0&id=e9137360&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9137360"]])

export default __exports__